import React from "react";
import { Link } from "react-router-dom";
import { projects } from "../data/projects";
import { cloudinaryImage } from "../utils/cloudinary";
import Contact from "../components/Contact";

export default function Projects() {
  return (
    <main className="min-h-screen bg-transparent pt-24">
      <section className="max-w-[1400px] mx-auto px-3 md:px-6 py-8 md:py-14" dir="rtl">
        <div className="text-right mb-8 md:mb-12">
          <div className="h-px w-28 bg-slate-500/70 mr-auto mb-5"></div>
          <h1 className="text-4xl md:text-5xl font-light text-slate-100 tracking-tight">
            פרויקטים
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-8">
          {projects.map((project) => (
            <article key={project.id} className="group">
              <Link to={`/projects/${project.id}`} className="block">
                <div className="relative overflow-hidden bg-black">
                  <img
                    src={cloudinaryImage(project.coverImage)}
                    alt={project.title}
                    className="w-full h-[360px] md:h-[420px] object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/18 opacity-100 group-hover:bg-black/6 transition" />
                </div>
                <div className="pt-5 text-center">
                  <h3 className="text-2xl md:text-3xl font-light text-slate-100 tracking-tight leading-tight">
                    {project.title}
                  </h3>
                  <p className="mt-1 text-base md:text-lg text-slate-400">{project.location}</p>
                  <span className="inline-block mt-3 text-sm md:text-base text-slate-200 border-b border-slate-500/70 pb-1">
                    לפרויקט מלא
                  </span>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </section>
      <Contact />
    </main>
  );
}
